import React, { useEffect, useState } from "react";

//css
import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Container, Row, Card, Button } from "react-bootstrap";

//ant design
import "antd/dist/antd.css";

//jquery
import $ from "jquery";

//action
import { getInterviews } from "../store/user/action";

//slider
import ItemsCarousel from "react-items-carousel";

//navbar
import Navbar from "./NavBar";
import { connect, useSelector } from "react-redux";

//dayjs
import dayjs from "dayjs";

const InterViewer = (props) => {
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const [data, setData] = useState([]);
  const [interviewData, setInterviewData] = useState({});
  const [activeIndex, setActiveIndex] = useState("tab1");
  const [textArea, setTextArea] = useState(false);

  const interviews = useSelector((state) => state.user.interviews);

  const _id = localStorage.getItem("id");
  const userType = localStorage.getItem("type");

  useEffect(() => {
    props.getInterviews(_id, userType);
  }, [_id, userType]);

  useEffect(() => {
    setData(interviews);
  }, [interviews]);

  useEffect(() => {
    handleChangeTab("tab1");
    setActiveIndex("tab1");
  }, []);

  const handleChangeTab = (index) => {
    debugger;
    const previousIndex = localStorage.getItem("PREVIOUS_INDEX");
    setActiveIndex(index);
    $(`#${previousIndex}`).removeClass("tabActive");
    $(`#${index}`).addClass("tabActive");
    localStorage.setItem("PREVIOUS_INDEX", index);
  };
  const handleCard = (index, data_) => {
    debugger;
    $("#pendingBtn").text("Submit Feedback");
    setInterviewData(data_);
    const previousIndex = localStorage.getItem("CARD_PREVIOUS_INDEX");

    $(`#${previousIndex}`).removeClass("cardActive");

    $(`#${index}`).addClass("cardActive");
    localStorage.setItem("CARD_PREVIOUS_INDEX", index);
    const previousIndex_ = localStorage.getItem("PREVIOUS_INDEX");
    if (previousIndex_ === "tab3") {
      setTextArea(true);
    } else {
      setTextArea(false);
    }
  };
  const handleCardActive = (index, data_) => {
    debugger;
    $(`.demo${index} #pendingBtn`).text("Submit Feedback");
    setInterviewData(data_);
    const previousIndex = localStorage.getItem("CARD_PREVIOUS_INDEX");
    $(`.demo${previousIndex} #pendingBtn`).text("Pending Feedback");

    $(`.demo${previousIndex}`).removeClass("cardActive");

    $(`.demo${index}`).addClass("cardActive");
    localStorage.setItem("CARD_PREVIOUS_INDEX", index);
    const previousIndex_ = localStorage.getItem("PREVIOUS_INDEX");
    if (previousIndex_ === "tab3") {
      setTextArea(true);
    } else {
      setTextArea(false);
    }
  };

  let now = dayjs();

  return (
    <>
      {/* <Navbar /> */}
      {/* <div className="bgColor">
        <Container fluid="sm"> */}
      {/* <Row className="py-5"> */}
      <Col className="py-3">
        <Card
          className="mx-auto"
          style={{
            borderRadius: 15,
            borderColor: "#3F8AF7",
          }}
        >
          <Card.Title className="p-3 font-weight-bold ">
            <Row className="text-center mainTab">
              {userType !== "interviewee" ? (
                <>
                  <Col
                    xs={12}
                    md={6}
                    className="tab py-3"
                    id="tab1"
                    onClick={() => handleChangeTab("tab1")}
                  >
                    Upcoming Interviews
                  </Col>

                  <Col
                    xs={12}
                    md={6}
                    className="tab py-3"
                    id="tab3"
                    onClick={() => handleChangeTab("tab3")}
                  >
                    Your Interviews
                  </Col>
                </>
              ) : (
                <>
                  <Col
                    xs={12}
                    md={6}
                    className="tab py-3"
                    id="tab1"
                    onClick={() => handleChangeTab("tab1")}
                  >
                    Upcoming Interviews
                  </Col>
                  <Col
                    xs={12}
                    md={6}
                    className="tab py-3"
                    id="tab2"
                    onClick={() => handleChangeTab("tab2")}
                  >
                    Previous Interviews
                  </Col>
                </>
              )}
            </Row>
          </Card.Title>
          <Card.Body>
            <div className="row d-none d-md-block">
              <div className="col-md-12 " id="myCarousel">
                <ItemsCarousel
                  infiniteLoop
                  requestToChangeActive={setActiveItemIndex}
                  activeItemIndex={activeItemIndex}
                  numberOfCards={3}
                  slidesToScroll={1}
                  leftChevron={<img src="/is-less-than.png" alt="left" />}
                  rightChevron={
                    <img src="/is-greater-than.png" alt="right" />
                  }
                >
                  {data.length > 0 ? (
                    data.map((data_, index) => {
                      if (activeIndex === "tab1") {
                        if (now.diff(data_.date.toDate(), "days") <= 0) {
                          return (
                            <div className="item col-sm-12 px-3">
                              <Card
                                className="py-5 mx-4 interviewCard"
                                id={`tab1${index}`}
                                onClick={() =>
                                  handleCard(`tab1${index}`, data_)
                                }
                              >
                                <div className="thumb-content text-center">
                                  <h5
                                    className="font-weight-Bold"
                                    style={{ textTransform: "capitalize" }}
                                  >
                                    {data_.interviewType}
                                  </h5>
                                  <h5
                                    className="font-weight-normal"
                                    style={{ textTransform: "capitalize" }}
                                  >
                                    {dayjs(data_.date.toDate()).format(
                                      "DD MMM'YY"
                                    )}
                                    &nbsp;{data_.time[0] + ":00"}
                                  </h5>
                                </div>
                              </Card>
                            </div>
                          );
                        }
                      }
                      if (activeIndex === "tab2") {
                        if (now.diff(data_.date.toDate(), "days") > 0) {
                          return (
                            <div className="item col-sm-12 px-3">
                              <Card
                                className="py-5 mx-4 interviewCard"
                                id={`tab2${index}`}
                                onClick={() =>
                                  handleCard(`tab2${index}`, data_)
                                }
                              >
                                <div className="thumb-content text-center">
                                  <h5
                                    className="font-weight-Bold"
                                    style={{ textTransform: "capitalize" }}
                                  >
                                    {data_.interviewType}
                                  </h5>
                                  <h5
                                    className="font-weight-normal"
                                    style={{ textTransform: "capitalize" }}
                                  >
                                    {dayjs(data_.date.toDate()).format(
                                      "DD MMM'YY"
                                    )}
                                    &nbsp;{data_.time[0] + ":00"}
                                  </h5>
                                </div>
                              </Card>
                            </div>
                          );
                        }
                      }
                      if (activeIndex === "tab3") {
                        return (
                          <div className="item col-sm-12 px-3">
                            <Card
                              className={`py-5 mx-4 interviewCard demo${index}`}
                              id={`tab3${index}`}
                              onClick={() =>
                                handleCardActive(index, data_)
                              }
                            >
                              <div className="thumb-content text-center">
                                <h5
                                  className="font-weight-Bold"
                                  style={{ textTransform: "capitalize" }}
                                >
                                  {data_.interviewType}
                                </h5>
                                <h5
                                  className="font-weight-normal"
                                  style={{ textTransform: "capitalize" }}
                                >
                                  {dayjs(data_.date.toDate()).format(
                                    "DD MMM'YY"
                                  )}
                                  &nbsp;{data_.time[0] + ":00"}
                                </h5>
                                {userType === "interviewer" && (
                                  <button
                                    className="btn-primary btn-xs mt-3 rounded"
                                    id="pendingBtn"
                                  >
                                    Pending Feedback
                                  </button>
                                )}
                              </div>
                            </Card>
                          </div>
                        );
                      }
                    })
                  ) : (
                    <p className="text-center">Nothig to Show</p>
                  )}
                </ItemsCarousel>
              </div>
            </div>

            <div className="row d-block d-md-none">
              <div className="col-md-12 " id="myCarousel">
                <ItemsCarousel
                  infiniteLoop
                  requestToChangeActive={setActiveItemIndex}
                  activeItemIndex={activeItemIndex}
                  numberOfCards={1}
                  slidesToScroll={1}
                  leftChevron={<img src="/is-less-than.png" alt="left" />}
                  rightChevron={
                    <img src="/is-greater-than.png" alt="right" />
                  }
                >
                  {data.length > 0 ? (
                    data.map((data_, index) => {
                      if (activeIndex === "tab1") {
                        if (now.diff(data_.date.toDate(), "days") <= 0) {
                          return (
                            <div className="item col-sm-12 px-3">
                              <Card
                                className="py-5 mx-4 interviewCard"
                                id={`tab1${index}`}
                                onClick={() =>
                                  handleCard(`tab1${index}`, data_)
                                }
                              >
                                <div className="thumb-content text-center">
                                  <h5
                                    className="font-weight-Bold"
                                    style={{ textTransform: "capitalize" }}
                                  >
                                    {data_.interviewType}
                                  </h5>
                                  <h5
                                    className="font-weight-normal"
                                    style={{ textTransform: "capitalize" }}
                                  >
                                    {dayjs(data_.date.toDate()).format(
                                      "DD MMM'YY"
                                    )}
                                    &nbsp;{data_.time[0] + ":00"}
                                  </h5>
                                </div>
                              </Card>
                            </div>
                          );
                        }
                      }
                      if (activeIndex === "tab2") {
                        if (now.diff(data_.date.toDate(), "days") > 0) {
                          return (
                            <div className="item col-sm-12 px-3">
                              <Card
                                className="py-5 mx-4 interviewCard"
                                id={`tab2${index}`}
                                onClick={() =>
                                  handleCard(`tab2${index}`, data_)
                                }
                              >
                                <div className="thumb-content text-center">
                                  <h5
                                    className="font-weight-Bold"
                                    style={{ textTransform: "capitalize" }}
                                  >
                                    {data_.interviewType}
                                  </h5>
                                  <h5
                                    className="font-weight-normal"
                                    style={{ textTransform: "capitalize" }}
                                  >
                                    {dayjs(data_.date.toDate()).format(
                                      "DD MMM'YY"
                                    )}
                                    &nbsp;{data_.time[0] + ":00"}
                                  </h5>
                                </div>
                              </Card>
                            </div>
                          );
                        }
                      }
                      if (activeIndex === "tab3") {
                        return (
                          <div className="item col-sm-12 px-3">
                            <Card
                              className={`py-5 mx-4 interviewCard demo${index}`}
                              id={`tab3${index}`}
                              onClick={() =>
                                handleCardActive(index, data_)
                              }
                            >
                              <div className="thumb-content text-center">
                                <h5
                                  className="font-weight-Bold"
                                  style={{ textTransform: "capitalize" }}
                                >
                                  {data_.interviewType}
                                </h5>
                                <h5
                                  className="font-weight-normal"
                                  style={{ textTransform: "capitalize" }}
                                >
                                  {dayjs(data_.date.toDate()).format(
                                    "DD MMM'YY"
                                  )}
                                  &nbsp;{data_.time[0] + ":00"}
                                </h5>
                                {userType === "interviewer" && (
                                  <button
                                    className="btn-primary btn-xs mt-3 rounded"
                                    id="pendingBtn"
                                  >
                                    Pending Feedback
                                  </button>
                                )}
                              </div>
                            </Card>
                          </div>
                        );
                      }
                    })
                  ) : (
                    <p className="text-center">Nothig to Show</p>
                  )}
                </ItemsCarousel>
              </div>
            </div>
            {/* <div id="triangle-up" className="pt-3 arrow up"></div> */}
            <div class="arrow_box">
              <Row className="mx-1 pt-5 pb-3 mb-5  ">
                <Col xs={12} md={5}>
                  {Object.keys(interviewData).length > 0 ? (
                    <>
                      <h5
                        className="py-1"
                        style={{ textTransform: "capitalize" }}
                      >
                        Interview Type:&nbsp;
                        {interviewData?.interviewType}
                      </h5>
                      <h6
                        className="py-1"
                        style={{ textTransform: "capitalize" }}
                      >
                        Interview Date & Time:&nbsp;
                        {dayjs(interviewData?.date?.toDate()).format(
                          "DD MMM'YY"
                        )}
                        &nbsp;{interviewData?.time}
                      </h6>
                      <h6
                        className="py-1"
                        style={{ textTransform: "capitalize" }}
                      >
                        Company:&nbsp;{interviewData?.company}
                      </h6>
                      <h6
                        className="py-1"
                        style={{ textTransform: "capitalize" }}
                      >
                        Resume Link:&nbsp;{interviewData?.resumeLink}
                      </h6>
                    </>
                  ) : (
                    <>
                      <h5
                        className="py-1"
                        style={{ textTransform: "capitalize" }}
                      >
                        Interview Type
                      </h5>
                      <h6
                        className="py-1"
                        style={{ textTransform: "capitalize" }}
                      >
                        Interview Date & Time
                      </h6>
                      <h6
                        className="py-1"
                        style={{ textTransform: "capitalize" }}
                      >
                        Company
                      </h6>
                      <h6
                        className="py-1"
                        style={{ textTransform: "capitalize" }}
                      >
                        Resume Link
                      </h6>
                    </>
                  )}
                  <h6
                    className="py-1"
                    style={{ textTransform: "capitalize" }}
                  >
                    Google Drive Link (For Interview)
                  </h6>
                  <div className="m-auto " style={{ textAlign: "center" }}>
                    {activeIndex === "tab3" &&
                      userType === "interviewer" ? (
                      <>
                        <button className="btn btn-outline-primary mt-3 mr-2">
                          INCLINED
                        </button>
                        <button className="btn btn-outline-danger mt-3">
                          NOT INCLINED
                        </button>
                      </>
                    ) : (
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="mt-3 shadow-lg btn btn-success mb-5"
                        style={{ border: "1px solid #427bde" }}
                      >
                        Final Vote
                      </Button>
                    )}
                  </div>
                </Col>
                <Col xs={12} md={7}>
                  <Card
                    style={{ border: "1px solid #000", borderRadius: 15 }}
                  >
                    <Card.Title className="text-center font-weight-bold pt-2">
                      Feedback :
                    </Card.Title>
                    <Card.Body>
                      {textArea ? (
                        <textarea
                          rows={8}
                          className="w-100"
                          placeholder="Enter Your Feedback Here..."
                        />
                      ) : (
                        `Lorem ipsum dolor sit amet. Qui numquam fuga nam
                            molestiae quia est rerum tenetur qui voluptas earum
                            sed incidunt sint et consequatur earum. Eos quis
                            reiciendis ut itaque labore nam possimus voluptas a
                            Quis amet ut ducimus vero ut dolor corrupti. Eum
                            doloribus aut natus vitae aut dolores quae ab totam
                            quia et tempora itaque ut possimus repellendus rerum
                            accusamus. Ad beatae odio aut esse dolores sit culpa
                            perspiciatis est labore consequatur.`
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          </Card.Body>
        </Card>
      </Col>
      {/* </Row> */}
      {/* </Container>
      </div> */}
    </>
  );
};

export default connect(null, { getInterviews })(InterViewer);
